import React from "react";
import { useState, useEffect } from "react";
import DateHelpers from "../Helper/DateHelpers";
import '../Styles/EditRegistrationForm.scss';


function EditRegistrationForm({ queriedRegistration }) {
   console.log("queried registration", queriedRegistration)

   const [viewPersonalInfo, setViewPersonalInfo] = useState(false)
   const [viewEmergencyContactInfo, setViewEmergencyContactInfo] = useState(false)
   const [viewInsuranceInfo, setViewInsuranceInfo] = useState(false)
   const [viewMedicalInfo, setViewMedicalInfo] = useState(false)
   const [viewEventInfo, setViewEventInfo] = useState(false)
   const [registrationData, setRegistrationData] = useState({})

   async function UpdateRegistration() {
      try {
         const response = await fetch('/updatedaycampregistration', {
            method: 'POST',
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
               registrationData
            })
         })
         let updateResult = await response.json();
         console.log("Update Result", updateResult.json)
         alert("Changes saved! Please refresh page to view latest.");
      }
      catch (error) {
         console.log("Exception", error)
      }
   }

   useEffect(() => {
      if (queriedRegistration) {
         setRegistrationData(queriedRegistration);
      }
   }, [queriedRegistration]);

   return (
      <div className="EditRegistrationContainer">
         <div className="EditRegistrationContent">
            <div className="EditRegistrationPersonalInformation">
               <div className="EditRegistrationPersonalInformationHeading" onClick={() => setViewPersonalInfo(!viewPersonalInfo)}>
                  <div className={`dropdown-arrow ${viewPersonalInfo ? 'open' : ''}`}>▶</div>
                  <div className="EditRegistrationPersonalInformationHeadingText">Personal Information</div>
               </div>
               {viewPersonalInfo === true &&
                  <div className="EditRegistrationPersonalInformationFields">
                     <div className="EditRegistrationField">
                        Name: {queriedRegistration.registration_first_name + " " + queriedRegistration.registration_last_name}
                     </div>
                     <div className="EditRegistrationField">
                        Date of Birth: {DateHelpers.getDisplayDate(queriedRegistration.registration_birth_date)}
                     </div>
                     <div className="EditRegistrationField">
                        Address Line One: {queriedRegistration.registration_mail_addr_1}
                     </div>
                     <div className="EditRegistrationField">
                        Address Line Two: {queriedRegistration.registration_mail_addr_2}
                     </div>
                     <div className="EditRegistrationField">
                        City: {queriedRegistration.registration_mail_city}
                     </div>
                     <div className="EditRegistrationField">
                        State: {queriedRegistration.registration_mail_state}
                     </div>
                     <div className="EditRegistrationField">
                        Zip: {queriedRegistration.registration_mail_zip}
                     </div>
                     <div className="EditRegistrationField">
                        Phone: {queriedRegistration.registration_phone_num}
                     </div>
                     <div className="EditRegistrationField">
                        Email Address: {queriedRegistration.registration_email_address}
                     </div>
                  </div>
               }
            </div>
            <div className="EditRegistrationEmergencyContactInformation">
               <div className="EditRegistrationEmergencyContactInformationHeading" onClick={() => setViewEmergencyContactInfo(!viewEmergencyContactInfo)}>
                  <div className={`dropdown-arrow ${viewEmergencyContactInfo ? 'open' : ''}`}>▶</div>
                  <div className="EditRegistrationEmergencyContactInformationHeadingText">Emergency Contact Information</div>
               </div>
               {viewEmergencyContactInfo === true &&
                  <div className="EditRegistrationEmergencyContactInformationFields">
                     <div className="EditRegistrationField">
                        Name: {queriedRegistration.registration_emergency_cont_name}
                     </div>
                     <div className="EditRegistrationField">
                        Relation: {queriedRegistration.registration_emergency_cont_rel}
                     </div>
                     <div className="EditRegistrationField">
                        Phone: {queriedRegistration.registration_emergency_cont_num}
                     </div>
                  </div>
               }
            </div>
            <div className="EditRegistrationInsuranceInformation">
               <div className="EditRegistrationInsuranceInformationHeading" onClick={() => setViewInsuranceInfo(!viewInsuranceInfo)}>
                  <div className={`dropdown-arrow ${viewInsuranceInfo ? 'open' : ''}`}>▶</div>
                  <div className="EditRegistrationInsuranceInformationHeadingText">Insurance Information</div>
               </div>
               {viewInsuranceInfo === true &&
                  <div className="EditRegistrationInsuranceInformationFields">
                     <div className="EditRegistrationField">
                        Insurance Company: {queriedRegistration.registration_insurance_cmpy}
                     </div>
                     <div className="EditRegistrationField">
                        ID Number: {queriedRegistration.registration_insurance_id_num}
                     </div>
                     <div className="EditRegistrationField">
                        Group Policy Number: {queriedRegistration.registration_insurance_group_num}
                     </div>
                     <div className="EditRegistrationField">
                        Name of Policy Holder: {queriedRegistration.registration_policy_holder_name}
                     </div>
                     <div className="EditRegistrationField">
                        Birthdate of Policy Holder: {queriedRegistration.registration_policy_holder_bd}
                     </div>
                  </div>
               }
            </div>
            <div className="EditRegistrationMedicalInformation">
               <div className="EditRegistrationMedicalInformationHeading" onClick={() => setViewMedicalInfo(!viewMedicalInfo)}>
                  <div className={`dropdown-arrow ${viewMedicalInfo ? 'open' : ''}`}>▶</div>
                  <div className="EditRegistrationMedicalInformationHeadingText">Medical Information</div>
               </div>
               {viewMedicalInfo === true &&
                  <div className="EditRegistrationMedicalInformationFields">
                     <div className="EditRegistrationField">
                        Has Asthma: {queriedRegistration.registration_has_asthma ? "Yes" : "No"}
                     </div>
                     <div className="EditRegistrationField">
                        Has Diabetes of Hypoglycemia: {queriedRegistration.registration_has_diab_or_hypgly ? "Yes" : "No"}
                     </div>
                     <div className="EditRegistrationField">
                        Has Environmental Allergies: {queriedRegistration.registration_has_env_allergies ? "Yes" : "No"}
                     </div>
                     <div className="EditRegistrationField">
                        Has Epilepsy: {queriedRegistration.registration_has_epilepsy ? "Yes" : "No"}
                     </div>
                     <div className="EditRegistrationField" >
                        Has Heart Condition: {queriedRegistration.registration_has_heart_condition ? "Yes" : "No"}
                     </div>
                     <div className="EditRegistrationField">
                        Has High Blood Pressure: {queriedRegistration.registration_high_bld_press ? "Yes" : "No"}
                     </div>
                     <div className="EditRegistrationField">
                        Has Lupus: {queriedRegistration.registration_has_lupus ? "Yes" : "No"}
                     </div>
                     <div className="EditRegistrationField" >
                        Heat Problem: {queriedRegistration.registration_has_heat_problem ? "Yes" : "No"}
                     </div>
                     <div className="EditRegistrationField">
                        Thyroid Problem: {queriedRegistration.registration_has_thyroid_problem ? "Yes" : "No"}
                     </div>
                     <div className="EditRegistrationField">
                        Drug Allergy Name: {queriedRegistration.registration_drug_allergy_name === "" ? "None" : queriedRegistration.registration_drug_allergy_name}
                     </div>
                     <div className="EditRegistrationField">
                        Emergency Action Taken: {queriedRegistration.registration_drug_allergy_emergency_action === "" ? "None" : queriedRegistration.registration_drug_allergy_emergency_action}
                     </div>
                     <div className="EditRegistrationField">
                        Food Allergy Name: {queriedRegistration.registration_food_allergy_name === "" ? "None" : queriedRegistration.registration_food_allergy_name}
                     </div>
                     <div className="EditRegistrationField">
                        Emergency Action Taken: {queriedRegistration.registration_food_allergy_emergency_action === "" ? "None" : queriedRegistration.registration_food_allergy_emergency_action}
                     </div>
                     <div className="EditRegistrationField">
                        Other Allergy Name: {queriedRegistration.registration_other_allergy_name === "" ? "None" : queriedRegistration.registration_other_allergy_name}
                     </div>
                     <div className="EditRegistrationField">
                        Emergency Action Taken: {queriedRegistration.registration_food_other_allergy_emergency_action === "" ? "None" : queriedRegistration.registration_other_allergy_emergency_action}
                     </div>
                     <div className="EditRegistrationField">
                        Medication Name: {queriedRegistration.registration_medication_name === "" ? "None" : queriedRegistration.registration_medication_name}
                     </div>
                     <div className="EditRegistrationField">
                        Medication Dose: {queriedRegistration.registration_medication_dose === "" ? "None" : queriedRegistration.registration_medication_dose}
                     </div>
                     <div className="EditRegistrationField">
                        Date of Last Tetanus Shot: {queriedRegistration.registration_last_tetanus_shot_dt != null ? DateHelpers.getDisplayDate(queriedRegistration.registration_last_tetanus_shot_dt) : ""}
                     </div>
                  </div>
               }
            </div>
            <div className="EditRegistrationEventInformation">
               <div className="EditRegistrationEventInformationHeading" onClick={() => setViewEventInfo(!viewEventInfo)}>
                  <div className={`dropdown-arrow ${viewEventInfo ? 'open' : ''}`}>▶</div>
                  <div className="EditRegistrationEventInformationHeadingText"> Event Information </div>
               </div>

               {viewEventInfo === true &&
                  <div className="EditRegistrationEventInformationFields">
                     <form>
                        {queriedRegistration.event_camp_type === 'Day Camp' &&
                           <div className="EditRegistrationEventInformationBuddyRequest">
                              <div className="EditRegistrationEventInformationBuddyRequestHeading">
                                 Buddy Request (Optional)
                              </div>
                              <div className="EditRegistrationEventInformationBuddyRequestFields">
                                 <div className="EditRegistrationEventInformationBuddyRequestInput">
                                    <label>First Name </label>
                                    <input
                                       type="text"
                                       required
                                       value={registrationData.registration_buddy_first_name || ""}
                                       onChange={(e) =>
                                          setRegistrationData((prevData) => ({
                                             ...prevData, registration_buddy_first_name: e.target.value,
                                          }))} />
                                 </div>
                                 <div className="EditRegistrationEventInformationBuddyRequestInput">
                                    <label>Last Name </label>
                                    <input
                                       type="text"
                                       required
                                       value={registrationData.registration_buddy_last_name || ""}
                                       onChange={(e) =>
                                          setRegistrationData((prevData) => ({
                                             ...prevData,
                                             registration_buddy_last_name: e.target.value,
                                          }))} />
                                 </div>
                              </div>
                           </div>
                        }
                        {queriedRegistration.event_camp_type === 'Retreat' &&
                           <div className="EditRegistrationEventInformationRetreat">
                              <div className="EditRegistrationField">
                                 Dates: {DateHelpers.getEventDateRange(queriedRegistration.event_begin_date, queriedRegistration.event_end_date)}
                              </div>
                              {queriedRegistration.registration_room_type === 'deluxe' &&
                                 <div className="EditRegistrationField">
                                    Room Type: Deluxe
                                 </div>
                              }
                              {queriedRegistration.event_camp_name === "Ladies' Retreat" &&
                                 <div className="EditRegistrationField">
                                    Craft Fair Table: {queriedRegistration.registration_craft_fair_table ? "Yes" : "No"}
                                 </div>
                              }
                              {queriedRegistration.event_camp_name === 'Couples Retreat' &&
                                 <div className="EditRegistrationField">
                                    Spouse Name: {queriedRegistration.registration_spouse_name || "None"}
                                 </div>
                              }
                              {queriedRegistration.event_camp_name === 'Father and Son Adventure' &&
                                 <div className="EditRegistrationField">
                                    Sons: {queriedRegistration.registration_father_son_adventure_son_names?.length > 0
                                       ? queriedRegistration.registration_father_son_adventure_son_names.join(", ")
                                       : "None"}
                                 </div>
                              }
                           </div>
                        }
                        {queriedRegistration.event_camp_type === 'Day Camp' &&
                           <div className="EditRegistrationEventInformationAuthorizedIndividuals">
                              <div className="EditRegistrationEventInformationAuthorizedIndividualsHeading">
                                 Authorized Individuals for Pickup
                              </div>
                              <div className="EditRegistrationEventInformationAuthorizedIndividualsFields">
                                 <div className="EditAuthorizedIndividualOne">
                                    <div className="EditAuthorizedIndividualHeading">
                                       Person One
                                    </div>
                                    <div className="EditAuthorizedIndividualFields">
                                       <div className="EditAuthorizedIndividualInput">
                                          <label>First Name </label>
                                          <input
                                             type="text"
                                             required
                                             value={registrationData.registration_day_camp_authorized_individual_one_first_name || ""}
                                             onChange={(e) =>
                                                setRegistrationData((prevData) => ({
                                                   ...prevData,
                                                   registration_day_camp_authorized_individual_one_first_name: e.target.value,
                                                }))} />
                                       </div>
                                       <div className="EditAuthorizedIndividualInput">
                                          <label>Last Name </label>
                                          <input
                                             type="text"
                                             required
                                             value={registrationData.registration_day_camp_authorized_individual_one_last_name || ""}
                                             onChange={(e) =>
                                                setRegistrationData((prevData) => ({
                                                   ...prevData,
                                                   registration_day_camp_authorized_individual_one_last_name: e.target.value,
                                                }))} />
                                       </div>
                                       <div className="EditAuthorizedIndividualInput">
                                          <label>Relationship </label>
                                          <input
                                             type="text"
                                             required
                                             value={registrationData.registration_day_camp_authorized_individual_one_relationship || ""}
                                             onChange={(e) =>
                                                setRegistrationData((prevData) => ({
                                                   ...prevData,
                                                   registration_day_camp_authorized_individual_one_relationship: e.target.value,
                                                }))} />
                                       </div>
                                       <div className="EditAuthorizedIndividualInput">
                                          <label>Phone Number </label>
                                          <input
                                             type="text"
                                             required
                                             value={registrationData.registration_day_camp_authorized_individual_one_phone || ""}
                                             onChange={(e) =>
                                                setRegistrationData((prevData) => ({
                                                   ...prevData,
                                                   registration_day_camp_authorized_individual_one_phone: e.target.value,
                                                }))} />
                                       </div>
                                    </div>
                                 </div>
                                 <div className="EditAuthorizedIndividualTwo">
                                    <div className="EditAuthorizedIndividualHeading">
                                       Person Two
                                    </div>
                                    <div className="EditAuthorizedIndividualFields">
                                       <div className="EditAuthorizedIndividualInput">
                                          <label>First Name </label>
                                          <input
                                             type="text"
                                             required
                                             value={registrationData.registration_day_camp_authorized_individual_two_first_name || ""}
                                             onChange={(e) =>
                                                setRegistrationData((prevData) => ({
                                                   ...prevData,
                                                   registration_day_camp_authorized_individual_two_first_name: e.target.value,
                                                }))} />
                                       </div>
                                       <div className="EditAuthorizedIndividualInput">
                                          <label>Last Name </label>
                                          <input
                                             type="text"
                                             required
                                             value={registrationData.registration_day_camp_authorized_individual_two_last_name || ""}
                                             onChange={(e) =>
                                                setRegistrationData((prevData) => ({
                                                   ...prevData,
                                                   registration_day_camp_authorized_individual_two_last_name: e.target.value,
                                                }))} />
                                       </div>
                                       <div className="EditAuthorizedIndividualInput">
                                          <label>Relationship </label>
                                          <input
                                             type="text"
                                             required
                                             value={registrationData.registration_day_camp_authorized_individual_two_relationship || ""}
                                             onChange={(e) =>
                                                setRegistrationData((prevData) => ({
                                                   ...prevData,
                                                   registration_day_camp_authorized_individual_two_relationship: e.target.value,
                                                }))} />
                                       </div>
                                       <div className="EditAuthorizedIndividualInput">
                                          <label>Phone Number </label>
                                          <input
                                             type="text"
                                             required
                                             value={registrationData.registration_day_camp_authorized_individual_two_phone || ""}
                                             onChange={(e) =>
                                                setRegistrationData((prevData) => ({
                                                   ...prevData,
                                                   registration_day_camp_authorized_individual_two_phone: e.target.value,
                                                }))} />
                                       </div>
                                    </div>
                                 </div>
                                 <div className="EditAuthorizedIndividualThree">
                                    <div className="EditAuthorizedIndividualHeading">
                                       Person Three
                                    </div>
                                    <div className="EditAuthorizedIndividualFields">
                                       <div className="EditAuthorizedIndividualInput">
                                          <label>First Name </label>
                                          <input
                                             type="text"
                                             required
                                             value={registrationData.registration_day_camp_authorized_individual_three_first_name || ""}
                                             onChange={(e) =>
                                                setRegistrationData((prevData) => ({
                                                   ...prevData,
                                                   registration_day_camp_authorized_individual_three_first_name: e.target.value,
                                                }))} />
                                       </div>
                                       <div className="EditAuthorizedIndividualInput">
                                          <label>Last Name </label>
                                          <input
                                             type="text"
                                             required
                                             value={registrationData.registration_day_camp_authorized_individual_three_last_name || ""}
                                             onChange={(e) =>
                                                setRegistrationData((prevData) => ({
                                                   ...prevData,
                                                   registration_day_camp_authorized_individual_three_last_name: e.target.value,
                                                }))} />
                                       </div>
                                       <div className="EditAuthorizedIndividualInput">
                                          <label>Relationship </label>
                                          <input
                                             type="text"
                                             required
                                             value={registrationData.registration_day_camp_authorized_individual_three_relationship || ""}
                                             onChange={(e) =>
                                                setRegistrationData((prevData) => ({
                                                   ...prevData,
                                                   registration_day_camp_authorized_individual_three_relationship: e.target.value,
                                                }))} />
                                       </div>
                                       <div className="EditAuthorizedIndividualInput">
                                          <label>Phone Number </label>
                                          <input
                                             type="text"
                                             required
                                             value={registrationData.registration_day_camp_authorized_individual_three_phone || ""}
                                             onChange={(e) =>
                                                setRegistrationData((prevData) => ({
                                                   ...prevData,
                                                   registration_day_camp_authorized_individual_three_phone: e.target.value,
                                                }))} />
                                       </div>
                                    </div>
                                 </div>
                                 <div className="EditAuthorizedIndividualFour">
                                    <div className="EditAuthorizedIndividualHeading">
                                       Person Four
                                    </div>
                                    <div className="EditAuthorizedIndividualFields">
                                       <div className="EditAuthorizedIndividualInput">
                                          <label>First Name </label>
                                          <input
                                             type="text"
                                             required
                                             value={registrationData.registration_day_camp_authorized_individual_four_first_name || ""}
                                             onChange={(e) =>
                                                setRegistrationData((prevData) => ({
                                                   ...prevData,
                                                   registration_day_camp_authorized_individual_four_first_name: e.target.value,
                                                }))} />
                                       </div>
                                       <div className="EditAuthorizedIndividualInput">
                                          <label>Last Name </label>
                                          <input
                                             type="text"
                                             required
                                             value={registrationData.registration_day_camp_authorized_individual_four_last_name || ""}
                                             onChange={(e) =>
                                                setRegistrationData((prevData) => ({
                                                   ...prevData,
                                                   registration_day_camp_authorized_individual_four_last_name: e.target.value,
                                                }))} />
                                       </div>
                                       <div className="EditAuthorizedIndividualInput">
                                          <label>Relationship </label>
                                          <input
                                             type="text"
                                             required
                                             value={registrationData.registration_day_camp_authorized_individual_four_relationship || ""}
                                             onChange={(e) =>
                                                setRegistrationData((prevData) => ({
                                                   ...prevData,
                                                   registration_day_camp_authorized_individual_four_relationship: e.target.value,
                                                }))} />
                                       </div>
                                       <div className="EditAuthorizedIndividualInput">
                                          <label>Phone Number </label>
                                          <input
                                             type="text"
                                             required
                                             value={registrationData.registration_day_camp_authorized_individual_four_phone || ""}
                                             onChange={(e) =>
                                                setRegistrationData((prevData) => ({
                                                   ...prevData,
                                                   registration_day_camp_authorized_individual_four_phone: e.target.value,
                                                }))} />
                                       </div>
                                    </div>
                                 </div>
                                 <div className="EditAuthorizedIndividualFive">
                                    <div className="EditAuthorizedIndividualHeading">
                                       Person Five
                                    </div>
                                    <div className="EditAuthorizedIndividualFields">
                                       <div className="EditAuthorizedIndividualInput">
                                          <label>First Name </label>
                                          <input
                                             type="text"
                                             required
                                             value={registrationData.registration_day_camp_authorized_individual_five_first_name || ""}
                                             onChange={(e) =>
                                                setRegistrationData((prevData) => ({
                                                   ...prevData,
                                                   registration_day_camp_authorized_individual_five_first_name: e.target.value,
                                                }))} />
                                       </div>
                                       <div className="EditAuthorizedIndividualInput">
                                          <label>Last Name </label>
                                          <input
                                             type="text"
                                             required
                                             value={registrationData.registration_day_camp_authorized_individual_five_last_name || ""}
                                             onChange={(e) =>
                                                setRegistrationData((prevData) => ({
                                                   ...prevData,
                                                   registration_day_camp_authorized_individual_five_last_name: e.target.value,
                                                }))} />
                                       </div>
                                       <div className="EditAuthorizedIndividualInput">
                                          <label>Relationship </label>
                                          <input
                                             type="text"
                                             required
                                             value={registrationData.registration_day_camp_authorized_individual_five_relationship || ""}
                                             onChange={(e) =>
                                                setRegistrationData((prevData) => ({
                                                   ...prevData,
                                                   registration_day_camp_authorized_individual_five_relationship: e.target.value,
                                                }))} />
                                       </div>
                                       <div className="EditAuthorizedIndividualInput">
                                          <label>Phone Number </label>
                                          <input
                                             type="text"
                                             required
                                             value={registrationData.registration_day_camp_authorized_individual_five_phone || ""}
                                             onChange={(e) =>
                                                setRegistrationData((prevData) => ({
                                                   ...prevData,
                                                   registration_day_camp_authorized_individual_five_phone: e.target.value,
                                                }))} />
                                       </div>
                                    </div>
                                 </div>
                                 <div className="EditAuthorizedIndividualSix">
                                    <div className="EditAuthorizedIndividualHeading">
                                       Person Six
                                    </div>
                                    <div className="EditAuthorizedIndividualFields">
                                       <div className="EditAuthorizedIndividualInput">
                                          <label>First Name </label>
                                          <input
                                             type="text"
                                             required
                                             value={registrationData.registration_day_camp_authorized_individual_six_first_name || ""}
                                             onChange={(e) =>
                                                setRegistrationData((prevData) => ({
                                                   ...prevData,
                                                   registration_day_camp_authorized_individual_six_first_name: e.target.value,
                                                }))} />
                                       </div>
                                       <div className="EditAuthorizedIndividualInput">
                                          <label>Last Name </label>
                                          <input
                                             type="text"
                                             required
                                             value={registrationData.registration_day_camp_authorized_individual_six_last_name || ""}
                                             onChange={(e) =>
                                                setRegistrationData((prevData) => ({
                                                   ...prevData,
                                                   registration_day_camp_authorized_individual_six_last_name: e.target.value,
                                                }))} />
                                       </div>
                                       <div className="EditAuthorizedIndividualInput">
                                          <label>Relationship </label>
                                          <input
                                             type="text"
                                             required
                                             value={registrationData.registration_day_camp_authorized_individual_six_relationship || ""}
                                             onChange={(e) =>
                                                setRegistrationData((prevData) => ({
                                                   ...prevData,
                                                   registration_day_camp_authorized_individual_six_relationship: e.target.value,
                                                }))} />
                                       </div>
                                       <div className="EditAuthorizedIndividualInput">
                                          <label>Phone Number </label>
                                          <input
                                             type="text"
                                             required
                                             value={registrationData.registration_day_camp_authorized_individual_six_phone || ""}
                                             onChange={(e) =>
                                                setRegistrationData((prevData) => ({
                                                   ...prevData,
                                                   registration_day_camp_authorized_individual_six_phone: e.target.value,
                                                }))} />
                                       </div>
                                    </div>
                                 </div>
                              </div>

                           </div>
                        }

                     </form>
                  </div>

               }
            </div>
            {queriedRegistration.event_camp_type === 'Day Camp' &&
               <div className="EditRegistrationUpdateButton">
                  <button onClick={() => UpdateRegistration(registrationData)}>
                     Update Information
                  </button>
               </div>
            }
         </div>
      </div>
   )
}
export default EditRegistrationForm
